import { PropsWithChildren } from 'react';

import { Box, Text, u } from '@ui';

import { screenHeader, screenHeaderEnd } from './WizardScreen.css';

type WizardScreenHeaderProps = PropsWithChildren<{
    start?: React.ReactNode;
    end?: React.ReactNode;
}>;
export const WizardScreenHeader = ({ children, start, end }: WizardScreenHeaderProps) => {
    return (
        <Box
            flexShrink={0}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            paddingInline={u(3)}
            className={screenHeader}
            flexDirection="row"
        >
            <Box
                display="flex"
                alignItems="center"
                flexBasis="auto"
                flexGrow={1}
                flexShrink={1}
                pt={{ xs: u(1.5), md: 0 }}
            >
                {start}
            </Box>

            <Box display={{ xs: 'none', md: 'flex' }}>
                <Text variant="h2">{children}</Text>
            </Box>

            <div className={screenHeaderEnd}>{end}</div>
        </Box>
    );
};

WizardScreenHeader.displayName = 'WizardScreen.Header';
